import Icon from '@/elements/Icon/Icon.component';
import './HeaderComponents.styles.css';
import type { ILink } from '@/types/base';
import clsx from 'clsx';

export const HeaderLevelOneLink = ({ text, href, className, ...props }: ILink) => {
  if (!href || !text) {
    return null;
  }

  return (
    <div className={clsx('headerLevelOneLink', className || '')}>
      <a
        href={href}
        className="headerLevelOneLink__navLink"
        target={props.target || '_self'}
        title={props.title || ''}
        aria-label={props.ariaLabel || ''}
      >
        {text}
        <Icon
          icon="chevron-right"
          className="headerLevelOneLink__navLink--icon"
        />
      </a>
    </div>
  );
};

export const HeaderLevelTwoLink = ({ text, href, ...props }: ILink) => {
  if (!href || !text) {
    return null;
  }

  return (
    <div className="headerLevelTwoLink">
      <a
        href={href}
        className="headerLevelTwoLink__navLink"
        target={props.target || '_self'}
        title={props.title || ''}
        aria-label={props.ariaLabel || ''}
      >
        Explore {text}
      </a>
    </div>
  );
};
